module.exports = __webpack_public_path__ + "img/loading-infinite-large.35c05e5c.svg";